<!-- ACTIONS -->
<div class="grid" *ngIf="!loadingMemory">
	<div [class]="actionLayout('left')">
		<p-menu #addBoardUser [model]="items" [popup]="true" appendTo="body"></p-menu>
		<p-button label="{{ 'ADD_USERS_DEVICE' | translate }}" [disabled]="taskRunning  || !online || isFullMemory()"
			icon="pi cm-plus" size="large" (click)="$event.stopPropagation(); addBoardUser.toggle($event)"
			[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
		</p-button>
	</div>
	<div [class]="actionLayout('center')">
		<div *ngIf="online" class="flex flex-column justify-content-center gap-2">
			<span class="flex align-items-center justify-content-center font-semibold">
				<i class="pi cm-memory-storage mr-1"></i>
				{{'MEMORY_USAGE' | translate }}: {{ boardUsersInfo?.Used }} / {{ boardUsersInfo?.Max }}
			</span>
			<p-progressBar [value]="getValueMemory()" styleClass="surface-900">
				<ng-template pTemplate="content" let-value>
					<span *ngIf="getValueMemory() > 6">{{getValueMemory()}} %</span>
				</ng-template>
			</p-progressBar>
		</div>
	</div>
	<div [class]="actionLayout('right')">
		<p-button label="{{ 'DELETE_ALL' | translate }}" [disabled]="taskRunning || !online"
			icon="pi cm-trash" size="large" (click)="$event.stopPropagation(); deleteBoardUsers()"
			[rounded]="false" [text]="true" severity="danger" styleClass="font-bold border-red-600">
		</p-button>
	</div>
	<div [class]="actionLayout('left')">
		<p-button label="{{ 'EXPORT_LIST' | translate }}" [disabled]="taskRunning || !online"
			icon="pi cm-cloud-arrow-up" size="large" (click)="$event.stopPropagation(); exportList()"
			[rounded]="false" [text]="true" severity="secondary" styleClass="font-bold border-0">
		</p-button>
	</div>
	<div [ngClass]="actionLayout('center')" [class]="this.screenWidth <= MIN_WD_COL4_MTMA && this.screenWidth >= MAX_MD_WIDTH ? 'flex justify-content-start gap-3' : 'flex justify-content-center gap-3'">
		<p-button label="{{ 'SYNC_DATA' | translate }}" [disabled]="taskRunning || !online || !isAccess()"
			icon="pi cm-cloud-sync" size="large" (click)="$event.stopPropagation(); syncData()"
			[rounded]="false" [text]="true" [severity]="needResync ? 'warning' : 'secondary'" [styleClass]="needResync ? 'text-base font-bold border-yellow-600 h-full' : 'text-base font-bold border-0'">
		</p-button>
		<p-button label="{{ 'RELOAD' | translate }}" [disabled]="taskRunning || !online"
			icon="pi cm-reload" size="large" (click)="$event.stopPropagation(); reloadBoardUsers()"
			[rounded]="false" [text]="true" severity="secondary" styleClass="font-bold border-0">
		</p-button>
	</div>
	<div [class]="actionLayout('right')">
		<p-button label="{{ 'DELETE_SELECTED' | translate }}" [disabled]="taskRunning || !online || !isSelectedKey()"
			icon="pi cm-trash" size="large" (click)="deleteSelected()" [rounded]="false" [text]="true" severity="danger"
			styleClass="font-bold border-red-600">
		</p-button>
	</div>
</div>

<!-- FILTER --> 
<!-- <p-accordion [activeIndex]="0"> commented: class="accordion-bg-gray"
	<p-accordionTab>
		<ng-template pTemplate="header">
			<div class="grid flex align-items-center w-full -mb-3">
				<div class="col-12 py-0" [class]="onExtendedMobile() ? 'flex justify-content-center' : ''">
					<span class="font-semibold white-space-nowrap">
						{{ 'FILTER' | translate }}
					</span>
				</div>
			</div>
		</ng-template> -->
		<form [formGroup]="filterGroup" class="grid mt-3 px-3">
			<!-- <div> -->
				<div [class]="col4Responsive()">
					<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
						[ngClass]="simpleInputTextLayout('borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('label')">{{
							'USER' | translate }}/{{
							'CODE' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('borderInput')">
							<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
								<i class="pi cm-search"></i>
								<input formControlName="nameFilter" pInputText type="text" [ngClass]="dynamicInputTextWidth()"
									id="board-users-table-input-search" placeholder="{{ 'NAME' | translate }}"
									maxlength="254" class="pr-5 surface-900"/>
							</span>
						</div>
					</div>
				</div>
				<div [class]="col4Responsive()">
					<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
						[ngClass]="simpleInputTextLayout('borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('label')">{{
							'TYPE' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('borderInput')">
							<p-dropdown [options]="typeList" formControlName="type" [ngClass]="dynamicInputTextWidth()"
								styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900">
								<ng-template let-item pTemplate="selectedItem">
									<div class="item flex align-items-center justify-content-center">
										<div class="flex align-items-center">{{ item.Label | translate }}</div>
									</div>
								</ng-template>
								<ng-template let-section pTemplate="item">
									<div class="item flex justify-content-center">
										<div>{{section.Label | translate }}</div>
									</div>
								</ng-template>
							</p-dropdown>
						</div>
					</div>
				</div>
				<div [class]="col4Responsive()">
					<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
						[ngClass]="simpleInputTextLayout('borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('label')">{{
							'FUNCTION' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('borderInput')">
							<p-dropdown [options]="functionList" formControlName="function" [ngClass]="dynamicInputTextWidth()"
								styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900"
								id="events-input-deviceFilter">
								<ng-template let-item pTemplate="selectedItem">
									<div class="item flex align-items-center justify-content-center">
										<div class="flex align-items-center">{{ item.Label | translate }}</div>
									</div>
								</ng-template>
								<ng-template let-section pTemplate="item">
									<div class="item flex align-items-center justify-content-center">
										<div>{{section.Label | translate }}</div>
									</div>
								</ng-template>
							</p-dropdown>
						</div>
					</div>
				</div>
				<div [class]="col4Responsive()" *ngIf="isRbe24230()">
					<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
						[ngClass]="simpleInputTextLayout('borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('label')">{{
							'GROUP' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('borderInput')">
							<p-dropdown [options]="groupList" formControlName="group" [ngClass]="dynamicInputTextWidth()"
								styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900">
								<ng-template let-item pTemplate="selectedItem">
									<div class="item flex align-items-center justify-content-center">
										<div class="flex align-items-center">{{ item.Label | translate }}</div>
									</div>
								</ng-template>
								<ng-template let-section pTemplate="item">
									<div class="item flex align-items-center justify-content-center">
										<div>{{section.Label | translate }}</div>
									</div>
								</ng-template>
							</p-dropdown>
						</div>
					</div>
				</div>
				<div [class]="col4Responsive()" *ngIf="isRbe24230()">
					<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
						[ngClass]="simpleInputTextLayout('borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('label')">{{
							'TEMPORARY' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('borderInput')">
							<p-dropdown [options]="temporaryList" formControlName="temporary"
								[ngClass]="dynamicInputTextWidth()"
								styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900">
								<ng-template let-item pTemplate="selectedItem">
									<div class="item flex align-items-center justify-content-center">
										<div class="flex align-items-center">{{ item.Label | translate }}</div>
									</div>
								</ng-template>
								<ng-template let-section pTemplate="item">
									<div class="item flex align-items-center justify-content-center">
										<div>{{section.Label | translate }}</div>
									</div>
								</ng-template>
							</p-dropdown>
						</div>
					</div>
				</div>
				<div [class]="col4Responsive()" *ngIf="isRbe24230()">
					<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
						[ngClass]="simpleInputTextLayout('borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('label')">{{
							'QUICK_EASY' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('borderInput')">
							<p-dropdown [options]="quickEasyList" formControlName="quickeasy"
								[ngClass]="dynamicInputTextWidth()"
								styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900">
								<ng-template let-item pTemplate="selectedItem">
									<div class="item flex align-items-center justify-content-center">
										<div class="flex align-items-center">{{ item.Label | translate }}</div>
									</div>
								</ng-template>
								<ng-template let-section pTemplate="item">
									<div class="item flex align-items-center justify-content-center">
										<div>{{section.Label | translate }}</div>
									</div>
								</ng-template>
							</p-dropdown>
						</div>
					</div>
				</div>
			<!-- </div> -->
		</form>
<!-- 	</p-accordionTab>
</p-accordion> -->
<!-- TREE TABLE -->
<div class="grid mt-0">
	<div class="col-12">
		<div class="card border-round">
			<p-treeTable *ngIf="boards !== undefined" [value]="boards" [scrollable]="true" [rows]="10" [paginator]="true"
				[totalRecords]="resultLength" [loading]="loading" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
				[showCurrentPageReport]="true" [scrollable]="true" sortMode="single" sortField="name" [sortOrder]="-1"
				selectionMode="checkbox" [(selectionKeys)]="selectionKeys" dataKey="Position">
				<!--(onLazyLoad)="loadBoardUsers($event)" [lazy]="true" -->
				<ng-template pTemplate="header">
					<tr>
						<th *ngIf="!underTablet()" class="flex justify-content-start ml-8 pl-4 mt-3" ttSortableColumn="nameStr">
							{{'NAME' | translate }}<p-treeTableSortIcon field="nameStr" />
						</th>
						<th *ngIf="!underTablet()" style="width: 150px">{{ 'TYPE' | translate }} - {{ 'CODE' | translate }}</th>
						<th *ngIf="!underTablet()" ttSortableColumn="Order">
							{{ 'POSITION' | translate}}<p-treeTableSortIcon field="Order" />
						</th>
						<th *ngIf="!underTablet()">{{ 'FUNCTION' | translate }}</th>
						<th *ngIf="!underTablet() && isRbe24230()">{{ 'GROUPS' | translate }}</th>
						<th *ngIf="!underTablet() && isRbe24230()">{{ 'TEMPORARY_ACCESS' | translate }}</th>
						<th [style]="underTablet() ? '' : 'width: 105px;'"></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-rowNode let-rowData="rowData">
					<tr [ttRow]="rowNode" [class]="(rowNode.level === 0) ? 'surface-400' : ''"
						[class]="underTablet() ? 'flex flex-column' : ''">
						<td [class]="underTablet() ? 'border-transparent' : ''">
							<div class="flex align-items-center justify-content-start text-left">
								<p-treeTableToggler *ngIf="rowNode.node.children.length > 0" [rowNode]="rowNode"></p-treeTableToggler>
								<p-treeTableCheckbox *ngIf="rowNode.node.children.length === 0" [value]="rowNode" [disabled]="isQuickEasy(rowData)"
									[class]="rowNode.parent !== null ? 'pl-5 pr-2' : 'pl-1 pr-2'" />
								<i class="pi {{getIconBoardUser(rowNode)}} text-3xl text-primary mr-3"></i>
								<div *ngIf="rowNode.node.children.length > 0">{{ rowData.GroupName || ('NO_NAME' | translate) |
									truncate:[20] }}</div>
								<div *ngIf="rowNode.node.children.length === 0">{{ rowData.Name || ('NO_NAME' | translate) |
									truncate:[20] }}</div>
							</div>
						</td>
						<td [class]="underTablet() ? 'border-transparent' : ''" [style]="!underTablet() ? 'width: 150px' : ''">
							<div [class]="underTablet() ? 'flex align-items-center justify-content-between' : ''">
								<div *ngIf="underTablet()" class="font-semibold">{{ 'TYPE' | translate }}</div>
								<div>{{getTypeDescription(rowData)}}</div>
							</div>
						</td>
						<td [class]="underTablet() ? 'border-transparent' : ''">
							<div [class]="underTablet() ? 'flex align-items-center justify-content-between' : ''">
								<div *ngIf="underTablet()" class="font-semibold">{{ 'POSITION' | translate }}</div>
								<div>{{ rowNode.node.children.length === 0 ? (rowData.Order + 1) : ' - ' }}</div>
							</div>
						</td>
						<td [class]="underTablet() ? 'border-transparent' : ''">
							<div [class]="underTablet() ? 'flex align-items-center justify-content-between' : ''">
								<div *ngIf="underTablet()" class="font-semibold">{{ 'FUNCTION' | translate }}</div>
								<div>{{ rowNode.node.children.length === 0 ? getFunctionDescription(rowData) : ' - ' }}</div>
							</div>
						</td>
						<td [class]="underTablet() ? 'border-transparent' : ''" *ngIf="isRbe24230()">
							<div [class]="underTablet() ? 'flex align-items-center justify-content-between' : ''">
								<div *ngIf="underTablet()" class="font-semibold">{{ 'GROUPS' | translate }}</div>
								<div>{{ rowNode.node.children.length === 0 ? getGroup(rowData) : ' - ' }}</div>
							</div>
						</td>
						<td [class]="underTablet() ? 'border-transparent' : ''" *ngIf="isRbe24230()">
							<div [class]="underTablet() ? 'flex align-items-center justify-content-between' : ''">
								<div *ngIf="underTablet()" class="font-semibold">{{ 'TEMPORARY_ACCESS' | translate }}</div>
								<div>{{ rowNode.node.children.length === 0 && (isTemporaryAccess(rowData) || isQuickEasy(rowData))?
									(getDate(rowData.DateFrom) |
									localizedDate: 'short':'UTC') + ' - ' + (getDate(rowData.DateTo) |
									localizedDate: 'short':'UTC') : ' - ' }}</div>
							</div>
						</td>
						<td [style]="underTablet() ? '' : 'width: 120px;'">
							<div class="flex align-items-center justify-content-end gap-1">
								<p-button pTooltip="{{ 'EDIT' | translate }}" tooltipPosition="bottom" icon="pi cm-pencil" size="large"
									(click)="editBoardUser(rowNode)" [disabled]="!online || taskRunning || isQuickEasy(rowData)"
									[rounded]="false" [text]="true" severity="secondary" *ngIf="!isQuickEasy(rowData)">
								</p-button>
								<p-button pTooltip="{{ 'DELETE' | translate }}"
									[disabled]="!online || rowNode.node.children.length>0 || taskRunning || isQuickEasy(rowData)"
									tooltipPosition="bottom" icon="pi cm-trash" size="large" (click)="deleteBoardUser(rowData)"
									[rounded]="false" [text]="true" severity="danger" *ngIf="!isQuickEasy(rowData)">
								</p-button>
								<i *ngIf="isQuickEasy(rowData)" class="pi cm-alert text-xl text-50 pr-2" tooltipPosition="bottom"
									pTooltip="{{ 'WARNING_QUICK_&_EASY' | translate }}"></i>
							</div>
						</td>
					</tr>
				</ng-template>
			</p-treeTable>
		</div>
	</div>
</div>

<div class="flex justify-content-center" *ngIf="loadingMemory">
	<p-progressSpinner ariaLabel="loading" styleClass="p-progressbar-small"></p-progressSpinner>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>